/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ResourceFile } from './ResourceFile';

export const ListFile: core.serialization.ObjectSchema<serializers.ListFile.Raw, Truvity.ListFile> =
    core.serialization.object({
        items: core.serialization.list(ResourceFile),
    });

export declare namespace ListFile {
    export interface Raw {
        items: ResourceFile.Raw[];
    }
}
